import { FormattedMessage } from 'react-intl';

import { WLIDS } from 'Constants';
import { NewModal } from 'Views/Components/Modal/NewModal';
import { appConfigStore } from 'Models/AppConfigStore';

interface StandbyOpenHoursModalProps {
	onClose: () => void;
}

export default function StandbyOpenHoursModal({ onClose }: StandbyOpenHoursModalProps) {
	return (
		<>
			<NewModal.Header>
				<NewModal.Title>
					<FormattedMessage id={WLIDS.standby.modalTitle} defaultMessage="Join standby" />
				</NewModal.Title>
			</NewModal.Header>
			<NewModal.Body>
				<FormattedMessage
					id={WLIDS.standby.listIsClosed}
					defaultMessage="The standby list will become available {hours}hrs before departure."
					values={{
						hours: appConfigStore.standbyOpenHoursBeforeDeparture,
					}}
				/>
			</NewModal.Body>
			<NewModal.Footer>
				<NewModal.ConfirmButton onClick={onClose}>Close</NewModal.ConfirmButton>
			</NewModal.Footer>
		</>
	);
}
